import React from "react";
import { useSelector } from "react-redux";
import { ItemCounter } from "../../Common/Components/ItemCounter";
import { RxCrossCircled } from "react-icons/rx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const LaundryItemCard = ({
  laundryItem,
  campaign,
  item,
  itemIndex,
  changeAddonQuantity,
  changeItemQuantity,
  toggleAddons,
  offer,
  bundleMessage,
  onNoteChange,
  description,
  editable = true,
}) => {
  const config = useSelector((x) => x.Config);

  const handleNoteChange = (e) => {
    onNoteChange(e.target.value);
  }

  return (
    <div className="service-laundry-item-card" key={`item-${laundryItem?.id}`}>
      {offer ? (
        <div className="col-12 mb-4">
          <span
            className="badge text-bg-dark d-flex align-items-center"
            style={{ width: "fit-content" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/bundle-stars.png"}
              alt=""
              height={18}
              className="me-1"
              style={{
                filter:
                  "invert(83%) sepia(64%) saturate(2152%) hue-rotate(357deg) brightness(97%) contrast(105%)",
              }}
            />
            BUNDLE OFFER
          </span>
        </div>
      ) : null}
      {campaign ? (
        <div className="col-12 text-end">
          <span className="badge text-bg-success">
            {campaign?.discount}% OFF
          </span>
        </div>
      ) : null}
      <div className="inner">
        <div className="service-laundry-item-details">
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={`${config?.["base_urls"]?.["laundry_items_image_url"]}/${laundryItem?.icon}`}
              alt=""
            />
            {description && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{description}</Tooltip>}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "4px",
                    cursor: "pointer",
                    zIndex: 5,
                  }}
                >
                  <i className="fa-regular fa-eye"></i>
                </span>
              </OverlayTrigger>
            )}
          </div>
          <div className="inner">
            <span className="name">{item.name}</span>
            {campaign ? (
              <del className="price text-muted">
                Rs. {item.actualPrice.toLocaleString()}
              </del>
            ) : null}
            <span className="price">Rs. {item.price.toLocaleString()}</span>
            {item.quantity >= 1 && (
              <div className="d-flex align-items-center gap-2">
                <label className="small fw-medium">Note:</label>

                <div className="position-relative">
                  <input
                    type="text"
                    value={item.item_note || ""}
                    placeholder="Add note here.."
                    onChange={handleNoteChange}
                    className="form-control rounded"
                    style={{ paddingRight: "28px", height: "32px", fontSize: "14px" }}
                  />
                  <RxCrossCircled
                    className="position-absolute"
                    style={{
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                    onClick={() => onNoteChange("")}
                  />
                </div>
              </div>
            )}

          </div>
        </div>
        <ItemCounter
          key={itemIndex}
          value={item.quantity}
          onChange={(v) => changeItemQuantity(itemIndex, v)}
          editable={editable}
        />
      </div>
      <div className="inner-mobile">
        <div className="service-laundry-item-details">
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={`${config?.["base_urls"]?.["laundry_items_image_url"]}/${laundryItem?.icon}`}
              alt=""
            />
            {description && (
              <OverlayTrigger
                placement="top"
                trigger={['hover', 'focus']}
                overlay={<Tooltip>{description}</Tooltip>}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "1px",
                    cursor: "pointer",
                    zIndex: 5,
                  }}
                >
                  <i className="fa-regular fa-eye"></i>
                </span>
              </OverlayTrigger>
            )}
          </div>
          <div className="inner" style={{ flexGrow: 1 }}>
            <span className="name">{item.name}</span>
          </div>
          <hr style={{ width: "100%" }} />
          <div className="inner">
            {campaign ? (
              <del className="price text-muted">
                Rs. {item.actualPrice.toLocaleString()}
              </del>
            ) : null}
            <span className="price">Rs. {item.price.toLocaleString()}</span>
          </div>
          <ItemCounter
            key={itemIndex}
            value={item.quantity}
            onChange={(v) => changeItemQuantity(itemIndex, v)}
            editable={editable}
          />
          {item.quantity >= 1 && (
              <div className="d-flex align-items-center gap-2 mt-2">
                <label className="small fw-medium">Note:</label>

                <div className="position-relative">
                  <input
                    type="text"
                    value={item.item_note || ""}
                    placeholder="Add note here.."
                    onChange={handleNoteChange}
                    className="form-control rounded"
                    style={{ paddingRight: "28px", height: "32px", fontSize: "14px" }}
                  />
                  <RxCrossCircled
                    className="position-absolute"
                    style={{
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                    onClick={() => onNoteChange("")}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
      {offer ? (
        <div className="card mt-3">
          <div className="card-body d-flex align-items-center">
            <div className="me-3">
              <div
                className="rounded bg-primary d-flex align-items-center justify-content-center position-relative"
                style={{ height: "35px", width: "35px" }}
              >
                <i className="fa-solid fa-basket-shopping"></i>
                {item.is_bundle_active ? (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-success"
                    style={{
                      height: "18px",
                      fontSize: "xx-small",
                      width: "18px",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className="fa-solid fa-check"></i>
                    <span className="visually-hidden">availed</span>
                  </span>
                ) : null}
              </div>
            </div>
            <div className="card-text flex-1">{bundleMessage}</div>
          </div>
        </div>
      ) : null}
      {item.quantity > 0 && laundryItem?.addons.length !== 0 ? (
        <div className="col-12 mt-3">
          <h6
            className="text-uppercase cursor-pointer mb-3"
            style={{
              color: "#828282",
              userSelect: "none",
              width: "fit-content ",
            }}
            onClick={() => toggleAddons(itemIndex)}
          >
            Addons
            <i
              className={`fa-solid ms-2 fa-chevron-${laundryItem?.showAddons ? "down" : "right"
                }`}
            ></i>
          </h6>
          {!laundryItem?.showAddons ? (
            <div className="row gy-2">
              {item.addons?.map((addon, addonIndex) => (
                <div
                  className="col-lg-6 col-md-12"
                  key={`item-${item.id}-addon-${addon.id}`}
                >
                  <div className="form-check">
                    <input
                      id={`item-${item.id}-addon-${addon.id}-checkbox-${addonIndex}-${itemIndex}`}
                      className="form-check-input"
                      type="checkbox"
                      checked={Boolean(addon.qty)}
                      onChange={(v) =>
                        changeAddonQuantity(
                          itemIndex,
                          addonIndex,
                          Number(v.target.checked)
                        )
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`item-${item.id}-addon-${addon.id}-checkbox-${addonIndex}-${itemIndex}`}
                    >
                      {addon.name} (Rs. {addon.price.toLocaleString()})
                    </label>
                  </div>
                </div>
                // <div className="d-flex justify-content-between align-items-center my-2">
                //   <p
                //     className="text-uppercase ms-2 mb-0"
                //     style={{ color: "#aaa" }}
                //   >
                //     {addon.name} (Rs.{" "}
                //     {addon.price.toLocaleString()})
                //   </p>
                //   <AddonCounter
                //     key={`item-${e.id}-addon-${addon.id}`}
                //     value={addon.qty}
                //     max={e.quantity}
                //     onChange={(v) =>
                //       changeAddonQuantity(
                //         itemIndex,
                //         addonIndex,
                //         v
                //       )
                //     }
                //   />
                // </div>
              ))}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default LaundryItemCard;
